import * as angular from "angular";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";

let LicenseInfoDialogComponent = {
    selector: "licenseInfoDialog",
    templateUrl:
        "/angular/components/product/license-info-dialog.component.html",
    bindings: {
        hideActions: "=?",
    },
    controller: class LicenseInfoDialog {
        // * bindings for typescript compiler *
        public hideActions?: any;
        // ************************************

        private permissionProvider: PermissionCheck;
        private userDataProvider: UserDataProvider;
        private signedInUser: User;
        private dialog: DialogUtils;

        constructor(
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.permissionProvider = PermissionCheck;
            this.userDataProvider = UserDataProvider;
            this.signedInUser = this.userDataProvider.getActiveUser();
            this.dialog = DialogUtils;
        }

        hide(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            if (this.permissionProvider.hasBillingRight()) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    locals: {
                        conversionType: conversionType,
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.dialog.show({
                    component: "vc-no-permission-upgrade",
                    targetEvent: ev,
                    locals: {},
                    size: "med",
                    style: "background: #f6f6f6",
                });
            }
        }
    },
};

angular
    .module("product")
    .component(LicenseInfoDialogComponent.selector, LicenseInfoDialogComponent);
